import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { EnvironmentalFateComponent } from './environmental-fate/environmental-fate.component';
import { EFSetupComponent } from './ef-setup/ef-setup/ef-setup.component';
import { EFSetupInputsComponent } from './ef-setup/ef-setup-inputs/ef-setup-inputs.component';
import { EFSetupModelsToBeRunComponent } from './ef-setup/ef-setup-models-to-be-run/ef-setup-models-to-be-run.component';
import { EFDataComponent } from './ef-data/ef-data/ef-data.component';
import { EFCakeTopologyComponent } from './ef-cake-topology/ef-cake-topology/ef-cake-topology.component';
import { EFCakeTopologyStructureComponent } from './shared/components/ef-cake-topology-structure/ef-cake-topology-structure.component';
import { EFRunComponent } from './ef-run/ef-run/ef-run.component';

@NgModule({
  declarations: [
    EnvironmentalFateComponent,
    EFSetupComponent,
    EFSetupInputsComponent,
    EFSetupModelsToBeRunComponent,
    EFDataComponent,
    EFCakeTopologyComponent,
    EFCakeTopologyStructureComponent,
    EFRunComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    AgGridModule
  ],
  exports: [
    EnvironmentalFateComponent,
    EFSetupComponent,
    EFSetupInputsComponent,
    EFSetupModelsToBeRunComponent,
    EFDataComponent,
    EFCakeTopologyComponent,
    EFCakeTopologyStructureComponent,
    EFRunComponent
  ]
})
export class EnvironmentalFateModule { }
